import {Card, Typography, Badge, Progress} from "antd";
import {useNavigate} from "react-router-dom";
import {CheckCircleFilled, CloseCircleFilled, PlayCircleOutlined} from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

function QuizItem({id, number, RQuizes}){
    let navigate = useNavigate();
    const { t } = useTranslation();
    const score = RQuizes[id];
    const isPassed = score >= 18;
    const isPlayed = score !== undefined;

    const handleOpenTest = (id)=>{
        navigate(`/quizes/${id}`);
    }

    const getStatusColor = () => {
        if (!isPlayed) return '#d9d9d9';
        return isPassed ? '#52c41a' : '#ff4d4f';
    };

    return (
        <Badge.Ribbon 
            text={isPlayed ? `${score}/20` : t('quiz_filter.new')} 
            color={getStatusColor()}
            style={{ display: isPlayed || !isPlayed ? 'block' : 'none' }}
        >
            <Card 
                hoverable 
                onClick={() => handleOpenTest(id)}
                style={{ 
                    borderRadius: '12px',
                    overflow: 'hidden',
                    borderTop: `4px solid ${getStatusColor()}`,
                    transition: 'all 0.3s'
                }}
                bodyStyle={{ padding: '20px 15px' }}
            >
                <div style={{ textAlign: 'center' }}>
                    <Title level={5} style={{ margin: '0 0 10px 0' }}>
                        {t('questions.tests')} №{number}
                    </Title>
                    
                    <div style={{ fontSize: '24px', marginBottom: '10px' }}>
                        {!isPlayed ? (
                            <PlayCircleOutlined style={{ color: '#1890ff' }} />
                        ) : isPassed ? (
                            <CheckCircleFilled style={{ color: '#52c41a' }} />
                        ) : (
                            <CloseCircleFilled style={{ color: '#ff4d4f' }} />
                        )}
                    </div>

                    {isPlayed && (
                        <Progress 
                            percent={(score / 20) * 100} 
                            size="small" 
                            showInfo={false} 
                            strokeColor={getStatusColor()} 
                        />
                    )}
                </div>
            </Card>
        </Badge.Ribbon>
    );
}

export default QuizItem;